import gql from "graphql-tag";
export const createDealerCompany = gql`
  mutation createCompany($managerId: String!, $accessGroupId: CompanyBelongsTo) {
    createCompany(oneCId: $managerId, accessGroup: $accessGroupId) {
      id
    }
  }
`;
